export const calvingErrorList = [
  'calvingCalfAtFoot',
  'calvingRunningWithBull',
  'calvingInCalf',
  'calvingRunningWithBullTag',
  'calvingRunningWithBullName',
  'calvingInCalfNaturalSireName',
  'calvingInCalfNaturalSireTag',
  'calvingInCalfAISireName',
  'calvingInCalfAISireTag',
  'calvingCalfAtFootNaturalSireName',
  'calvingCalfAtFootNaturalSireTag',
  'calvingCalfAtFootAISireName',
  'calvingCalfAtFootAISireTag'
];

export const getCalvingErrors = animal => {
  const errors = {};
  if (!animal || !animal.calving) return {};
  const calving = animal.calving;
  if ((animal.sex && animal.sex === 'male') ||
  (['YoungBulls'].includes(animal.type))) {
    if (calving.calfAtFoot) {
      errors.calvingCalfAtFoot = 'animal is male';
    }
    if (calving.runningWithBull) {
      errors.calvingRunningWithBull = 'animal is male';
    }
    if (calving.inCalf) {
      errors.calvingInCalf = 'animal is male';
    }
  }
  if (calving.inCalf && calving.runningWithBull) {
    errors.calvingRunningWithBull =
      'animal is in calf - "running with bull" is invalid';
  }
  if (calving.runningWithBull) {
    if (!calving.runningWithBull.name && !calving.runningWithBull.tag) {
      errors.calvingRunningWithBullTag = 'tag or name is required';
      errors.calvingRunningWithBullName = 'name or tag is required';
    }
    if (calving.runningWithBull.bullIn > calving.runningWithBull.bullOut) {
      errors.calvingRunningWithBullBullIn = 'Bull left before it arrived';
      errors.calvingRunningWithBullBullOut = 'Bull left before it arrived';
    }
  }
  if (calving.inCalf) {
    let sireIncluded = false;
    ['naturalSire', 'aiSire'].forEach(sire => {
      ['name', 'tag'].forEach(attr => {
        try {
          if (calving.inCalf[sire][attr]) sireIncluded = true;
        } catch (error) { /* */ }
      });
    });
    if (!sireIncluded) {
      errors.calvingInCalfNaturalSireName =
        'Some info about the sire is required';
      errors.calvingInCalfNaturalSireTag =
        'Some info about the sire is required';
      errors.calvingInCalfAISireName = 'Some info about the sire is required';
      errors.calvingInCalfAISireTag = 'Some info about the sire is required';
    }
  }
  if (calving.calfAtFoot) {
    let sireIncluded = false;
    ['naturalSire', 'aiSire'].forEach(sire => {
      ['name', 'tag'].forEach(attr => {
        try {
          if (calving.calfAtFoot[sire][attr]) sireIncluded = true;
        } catch (error) { /* */ }
      });
    });
    if (!sireIncluded) {
      errors.calvingCalfAtFootNaturalSireName =
        'Some info about the sire is required';
      errors.calvingCalfAtFootNaturalSireTag =
        'Some info about the sire is required';
      errors.calvingCalfAtFootAISireName =
        'Some info about the sire is required';
      errors.calvingCalfAtFootAISireTag =
        'Some info about the sire is required';
    }
  }
  return errors;
};

export const newAnimalCalvingFieldsHaveChanged = animal => {
  if (!animal) return false;
  if (!animal.calving) return false;
  const calving = animal.calving;
  if (calving.runningWithBull || calving.inCalf || calving.calfAtFoot) {
    return true;
  }
  return false;
};

export const animalCalvingFieldsHaveChanged = (animal1, animal2) => {
  if (!!animal1.calving !== !!animal2.calving) return true;
  if (animal1.calving) {
    const calving1 = animal1.calving;
    const calving2 = animal2.calving;
    if (!!calving1.runningWithBull !== !!calving2.runningWithBull) return true;
    if (!!calving1.inCalf !== !!calving2.inCalf) return true;
    if (!!calving1.calfAtFoot !== !!calving2.calfAtFoot) return true;

    // Running With Bull
    const running1 = calving1.runningWithBull;
    const running2 = calving2.runningWithBull;
    if (running1) {
      if (running1.name !== running2.name) return true;
      if (running1.tag !== running2.tag) return true;
      if (running1.bullIn !== running2.bullIn) return true;
      if (running1.bullOut !== running2.bullOut) return true;
    }

    // Calf At Foot
    let calf1 = calving1.calfAtFoot;
    let calf2 = calving2.calfAtFoot;
    if (calf1) {
      if (!!calf1.naturalSire !== !!calf2.naturalSire) return true;
      if (calf1.naturalSire) {
        const sire1 = calf1.naturalSire;
        const sire2 = calf2.naturalSire;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (!!calf1.aiSire !== !!calf2.aiSire) return true;
      if (calf1.aiSire) {
        const sire1 = calf1.aiSire;
        const sire2 = calf2.aiSire;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (!!calf1.sweeperBull !== !!calf2.sweeperBull) return true;
      if (calf1.sweeperBull) {
        const sire1 = calf1.sweeperBull;
        const sire2 = calf2.sweeperBull;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (calf1.birthDate !== calf2.birthDate) return true;
      if (calf1.animalCategory !== calf2.animalCategory) return true;
    }

    // In calf
    calf1 = calving1.inCalf;
    calf2 = calving2.inCalf;
    if (calf2) {
      if (!!calf1.naturalSire !== !!calf2.naturalSire) return true;
      if (calf1.naturalSire) {
        const sire1 = calf1.naturalSire;
        const sire2 = calf2.naturalSire;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (!!calf1.aiSire !== !!calf2.aiSire) return true;
      if (calf1.aiSire) {
        const sire1 = calf1.aiSire;
        const sire2 = calf2.aiSire;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (!!calf1.sweeperBull !== !!calf2.sweeperBull) return true;
      if (calf1.sweeperBull) {
        const sire1 = calf1.sweeperBull;
        const sire2 = calf2.sweeperBull;
        if (sire1.name !== sire2.name) return true;
        if (sire1.tag !== sire2.tag) return true;
      }
      if (calf1.predictedBirth !== calf2.predictedBirth) return true;
      if (calf1.scanDate !== calf2.scanDate) return true;
    }
  }
  return false;
};
